@if (saniupEmployee() && errorCenterService.errors().length > 0) {
  <button
    type="button"
    mat-icon-button
    [matBadge]="errorCenterService.errors().length - checkedErrorCounter()"
    [matBadgeHidden]="errorCenterService.errors().length === checkedErrorCounter()"
    (click)="open()"
    class="indicator"
    [class.error-indicator]="errorCenterService.errors().length !== checkedErrorCounter()"
    matTooltip="Fehlerzentrale öffnen"
  >
    <mat-icon>error</mat-icon>
  </button>
}
